module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-item",
    style: ({
      width: _vm.width,
      height: _vm.height,
      'background-image': ("url(" + _vm.imgUrl + ")")
    }),
    on: {
      "click": _vm.handleClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72ab0212!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide/slide-item.vue
// module id = 57
// module chunks = 2 12